import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const OutlineVisibilityIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 16,
    width,
    height,
    color = 'currentColor',
    onClick,
    strokeWidth = 1.6,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M2.5 12C4.5 8.2 8 5.5 12 5.5C16 5.5 19.5 8.2 21.5 12C19.5 15.8 16 18.5 12 18.5C8 18.5 4.5 15.8 2.5 12Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="12" cy="12" r="3.1" stroke={color} strokeWidth={strokeWidth} fill="none" />
    </BaseIcon>
  ),
);

OutlineVisibilityIcon.displayName = 'OutlineVisibilityIcon';
